import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFCopyIconProps = Omit<SvgIconProps, "color"> & {
  color?: string;
};

/**
 * @param param0
 * @returns
 * @note 피그마에서 사이즈가 정사각형이 아닌 이슈로 `SvgIcon` 컴포넌트는 사용하지 않음.
 */
export default function SFCopyIcon({ color = "white" }: SFCopyIconProps) {
  return (
    // <SvgIcon {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3998 18.9992H6.40065C6.02555 19.0122 5.66187 18.8689 5.39647 18.6035C5.13107 18.3381 4.98778 17.9744 5.00082 17.5993V10.6002C4.98778 10.2251 5.13107 9.86138 5.39647 9.59598C5.66187 9.33058 6.02555 9.18729 6.40065 9.20033H9.20033V6.40065C9.18729 6.02555 9.33058 5.66187 9.59598 5.39647C9.86138 5.13107 10.2251 4.98778 10.6002 5.00082H17.5993C17.9744 4.98778 18.3381 5.13107 18.6035 5.39647C18.8689 5.66187 19.0122 6.02555 18.9992 6.40065V13.3998C19.012 13.7749 18.8686 14.1384 18.6033 14.4038C18.3379 14.6691 17.9744 14.8125 17.5993 14.7997H14.7997V17.5993C14.8125 17.9744 14.6691 18.3379 14.4038 18.6033C14.1384 18.8686 13.7749 19.012 13.3998 18.9992ZM6.40065 10.6002V17.5993H13.3998V14.7997H10.6002C10.2251 14.8125 9.86156 14.6691 9.59621 14.4038C9.33086 14.1384 9.1875 13.7749 9.20033 13.3998V10.6002H6.40065ZM10.6002 6.40065V13.3998H17.5993V6.40065H10.6002Z"
        fill={color}
      />
    </svg>

    // </SvgIcon>
  );
}
